var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H54C57.0376 0.5 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96244 39.5 0.5 37.0376 0.5 34V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H54C57.0376 0.5 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96244 39.5 0.5 37.0376 0.5 34V6Z",
    stroke: "#f4fdfa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4424 14.1738C32.8889 14.1738 30.6069 15.4975 30.6069 17.9426C30.6069 20.747 34.654 20.9407 34.654 22.3497C34.654 22.943 33.9743 23.474 32.813 23.474C31.1653 23.474 29.9337 22.732 29.9337 22.732L29.4067 25.1998C29.4067 25.1998 30.8254 25.8266 32.7089 25.8266C35.5007 25.8266 37.6978 24.4381 37.6978 21.9508C37.6978 18.9873 33.6338 18.7994 33.6338 17.4919C33.6338 17.0271 34.1918 16.5181 35.3495 16.5181C36.656 16.5181 37.7216 17.0577 37.7216 17.0577L38.2375 14.6745C38.2375 14.6745 37.0775 14.1738 35.4421 14.1738H35.4424ZM12.0795 14.3538L12.0176 14.7134C12.0176 14.7134 13.0918 14.91 14.0595 15.3024C15.3055 15.752 15.394 16.0141 15.6039 16.827L17.8903 25.6408H20.9553L25.6771 14.3538H22.6192L19.5851 22.0279L18.3471 15.5227C18.2337 14.7782 17.6584 14.3534 16.9546 14.3534H12.0799L12.0795 14.3538ZM26.9068 14.3538L24.5081 25.6408H27.4241L29.8142 14.3538H26.9068ZM43.1702 14.3538C42.4671 14.3538 42.0945 14.7303 41.8213 15.388L37.5491 25.6408H40.607L41.1985 23.9319H44.9237L45.2834 25.6408H47.9816L45.6279 14.3538H43.1702ZM43.568 17.4033L44.4745 21.6387H42.0463L43.5683 17.4033H43.568Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa_logo.19f5fa94b31dce264b7440f22046b1a9.svg";
export { ForwardRef as ReactComponent };